<template>
  <div class="us_app">
    <section class="user_section">
      <div class="title jc">
        <h2>적립금 내역</h2>
      </div>

      <article class="view cmnity">
        <!-- 검색 영역 -->
        <div class="search_box" style="flex-wrap: wrap">
          <div class="flex items-center w100 mb10">
            <span class="mw80 fwb">조회기간</span>
            <Datepicker
              class="dp-wide"
              v-model="searchInfo.startDate"
              :defaultDate="searchInfo.startDate"
              :format="'YYYY-MM-DD'"
            />
            <span class="ml10 mr10">~</span>
            <Datepicker
              class="dp-wide"
              v-model="searchInfo.endDate"
              :defaultDate="searchInfo.endDate"
              :format="'YYYY-MM-DD'"
            />
            <button class="btn btn_md btn_darkbrown" style="margin-left: auto" @click="fn_search">검색</button>
            <button class="btn btn_md btn_brown" style="margin-left: 8px" @click="fn_openChargeModal">적립금 충전</button>
          </div>
        </div>

        <!-- 요약 카드 -->
        <div class="flex mb20">
          <div class="summary_card_main">
            <p class="summary_label_main">현재 잔여 적립금</p>
            <p class="summary_value_main">{{ fn_comma_won(currentDeposit) }} 원</p>
          </div>
        </div>

        <p class="w100 mb10">
          총 <strong> {{ searchInfo.pageInfo.totPage }} </strong>건
        </p>

        <!-- 목록 -->
        <div class="tab_contents">
          <div class="lay_left">
            <div class="table_list">
              <table class="list">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>구분</th>
                    <th>금액</th>
                    <th>잔액</th>
                    <th>사유</th>
                    <th>일시</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="depositList.length === 0">
                    <td colspan="6"><span>데이터가 없습니다.</span></td>
                  </tr>
                  <tr v-for="(item, index) in depositList" :key="index">
                    <td>
                      <span>{{
                        searchInfo.pageInfo.totPage -
                        (searchInfo.pageInfo.page - 1) * searchInfo.pageInfo.pageSize -
                        index
                      }}</span>
                    </td>
                    <td>
                      <span >{{ item.tx_type_nm }}</span>
                    </td>
                    <td>
                      <span :class="item.tx_type === 'U' || item.tx_type === 'M' || item.tx_type === 'E'? 'font_red' : 'font_green'">
                        {{ item.tx_type === 'U' || item.tx_type === 'M' || item.tx_type === 'E' ? '-' : '+' }}{{ fn_comma_won(item.deposit) }} 원
                      </span>
                    </td>
                    <td>
                      <span :class="item.tx_type === 'U' || item.tx_type === 'M' || item.tx_type === 'E'? 'font_red' : 'font_green'">
                        {{ fn_comma_won(item.after_deposit) }} 원
                      </span>
                    </td>
                    <td>
                      <span >{{ item.reason }}</span>
                    </td>
                    <td>
                      <span>{{ item.reg_dt }}</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <Pagination
              :pageInfo="searchInfo.pageInfo"
              @clickPage="fn_movePage"
              v-show="pagingShow"
            />
          </div>
        </div>
      </article>
    </section>

    <deposit-request-modal
      :isShow="showChargeModal"
      :clinicDoctorId="searchInfo.clinic_doctor_id"
      @close="showChargeModal = false"
      @showAlert="fn_open_alert"
      @reload="fn_search"
    />

    <alert-modal
      :id="'alert'"
      :text="showAlertMsg"
      :btnRight="'확인'"
      :oneBtn="false"
      :isShow="showAlert"
      :className="'btn_brown'"
      :closeEventValue="closeEventValue"
      @closeEvent="oncCloseEvent"
      v-on:update:showSetting="fn_showSet"
    />
  </div>
</template>

<script>
import axios from 'axios'
import commonUtil from '@/mixin/commonUtil'
import alertutill from '@/mixin/alertModalUtill'
import Pagination from '@/components/AdminPagination.vue'
import Datepicker from '@/components/Datepicker.vue'
import AlertModal from '@/modal/common/alertModal.vue'
import DepositRequestModal from '@/modal/user/depositRequestModal.vue'

export default {
  components: {
    Pagination,
    Datepicker,
    AlertModal,
    DepositRequestModal,
  },
  mixins: [commonUtil, alertutill],
  data() {
    return {
      searchInfo: {
        clinic_doctor_id: '',
        startDate: '',
        endDate: '',
        pageInfo: {
          page: 1,
          pageSize: 10,
          totPage: 0,
        },
      },
      pagingShow: false,
      depositList: [],
      currentDeposit: 0,
      showChargeModal: false,
    }
  },
  created() {
    this.searchInfo.clinic_doctor_id =
      this.$store.getters['clinicDoctorInfo/getClinicDoctorId']
  },
  mounted() {
    this.searchInfo.startDate = this.getAddMonthDate(-3)
    this.searchInfo.endDate = this.getCurrentDate()
    this.fn_search();
  },
  methods: {
    fn_search() {
      this.searchInfo.pageInfo.page = 1
      this.fn_load()
    },
    fn_load() {
      axios
        .post('/api/user/mypage/getDepositList', this.searchInfo)
        .then((res) => {
          this.depositList = res.data.depositList
          this.currentDeposit = res.data.currentDepositInfo.deposit_balance;

          this.searchInfo.pageInfo.totPage = res.data.totCnt;
          this.pagingShow = this.searchInfo.pageInfo.totPage > 0
        })
        .catch((err) => console.log(err))
    },
    fn_movePage(page) {
      this.searchInfo.pageInfo.page = page
      this.fn_load()
    },
    oncCloseEvent() {
      this.fn_search()
    },
    fn_openChargeModal() {
      this.showChargeModal = true
    },
  },
}
</script>

<style scoped>
.summary_card_main {
  width: 100%;
  border: 2px solid #8b6b3d;
  border-radius: 10px;
  padding: 20px 32px;
  background: #fdf3e3;
  text-align: center;
}
.summary_label_main {
  font-size: 14px;
  color: #7a5c2e;
  font-weight: 600;
  margin-bottom: 10px;
}
.summary_value_main {
  font-size: 28px;
  font-weight: bold;
  color: #1a5fa8;
}
</style>